import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Bàn làm việc cũ (QĐ 0245/0361) — từ QĐ 0368 là không gian làm việc một đơn ở
 * /retouch/orders/$orderId. Giữ đường này để link cũ (tin nhắn, chuông) không gãy.
 */
export const Route = createFileRoute("/_app/gallery/orders/$orderId/fix-board")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/retouch/orders/$orderId", params: { orderId: params.orderId }, replace: true });
  },
});
